
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cardprocessingoffers/contact-us",
      function () {
        return require("private-next-pages/cardprocessingoffers/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cardprocessingoffers/contact-us"])
      });
    }
  